import Swal from "sweetalert2";

export default function alertError(error: any) {
    Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message
    })
}